<template>
    <van-cell-group class="order-info">
        <van-cell title="门店名称" :value="shop_name" />
        <van-cell title="下单时间" :value="create_date" />
        <van-cell title="付款方式" :value="pay_style_name" />
        <van-cell title="收车方式" :value="receive_style_name" />
        <van-cell title="总金额" :value="totalAmount" />
        <van-cell title="日期" :value="receive_plan_date" />
        <van-cell title="状态" :value="state_name" />
    </van-cell-group>
</template>

<script>
import { 
    CellGroup,
    Cell
} from 'vant'
import { UsedCarOrderApi } from '@/api/usedcar'
import moment from 'moment'
import { toThousandsNoDecimal } from '@/utils/formatutils'

export default {
    name: 'UsedCarOrderInfo',
    components: {
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell
    },
    props: ["orderid"],
    data() {
        return {
            shop_name: null,
            create_date: null,
            pay_style_name: null,
            receive_style_name: null,
            channel_amount: 0,
            deposit: 0,
            shop_server_amount: 0,
            receive_plan_date: null,
            state_name: '',
            totalAmount: ''
        }
    },
    methods: {
        show(id) {
            var that = this
            this.axios.get(UsedCarOrderApi + id + '/').then((ret) => {
                console.log(ret)
                that.shop_name = ret.shop_name
                that.create_date = moment(new Date(ret.create_date)).format('YYYY-MM-DD HH:mm:ss') 
                that.pay_style_name = ret.pay_style_name
                that.receive_style_name = ret.receive_style_name
                that.channel_amount = ret.channel_amount
                that.deposit =ret.deposit
                that.shop_server_amount = ret.shop_server_amount
                that.receive_plan_date = ret.receive_plan_date
                that.state_name = ret.state_name
                that.totalAmount = toThousandsNoDecimal((ret.channel_amount + ret.deposit + ret.shop_server_amount)/10000)

                that.$emit('returnorder',ret)
            })
        },
    }
}
</script>

<style lang="less" scoped>
.order-info {
    // display: flex;
    // justify-content:space-between;

    // .label-title {
    //     font-size: 1.1em;
    //     margin-bottom: 4px;
    // }
    // .label-content {
    //     font-size: 1.1em;
    //     margin-bottom: 4px;
    // }
}
</style>
